$('.baptist-online-breadcrumb-ellipsis').on('click', function () {
    var $breadcrumbComponent = $(this).closest('.baptist-online-breadcrumb');

    // Reveal hidden breadcrumb items inside this breadcrumb component
    $breadcrumbComponent.find('.breadcrumb-hidden').css('display', 'inline-block');

    // Hide the ellipsis container (which includes the / slash if styled via :after)
    $(this).closest('.baptist-online-breadcrumb-ellipsis-container').hide();
});